import * as yup from 'yup';

function serviceSiteName(formatMessage) {
  return yup
    .string()
    .required(
      formatMessage({
        id: 'EDITFORM_SERVICESITENAME_FIELD_IS_REQUIRED',
        defaultMessage: 'Service Site Name is required',
      }),
    )
    .max(
      64,
      formatMessage({
        id: 'EDITFORM_SERVICESITENAME_FIELD_MAX_CHARS_64',
        defaultMessage: 'Service Site Name should be less than 64 chars',
      }),
    );
}

function status(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'EDITFORM_STATUS_FIELD_IS_REQUIRED',
      defaultMessage: 'Status is required',
    }),
  );
}

const validationSchema = formatMessage =>
  yup
    .object({
      serviceSiteName: serviceSiteName(formatMessage),
      status: status(formatMessage),
    })
    .required();

export default validationSchema;
